export enum EmploymentOpenPeriodCalculation {
StartDate,
EndDate,
Calendar,
}
